import Axios from "axios";
import { BaseService } from "./BaseService";
import { CambiarEstadoFactura, EnviarFactura, Factura, FacturaCuentaContable, FacturaFiltro, ReplicacionFactura } from "@/model/Factura";
import { Fichero } from "@/model/Fichero";
import { FacturaDetalleImpuestoCambiarContrapartida } from "@/model/FacturaDetalleImpuesto";

BaseService.loadAxios();

const RESOURCE_NAME = "/factura";

export class FacturaService {
    
    public static async getFacturasAsync(filtro: FacturaFiltro) {
        return await Axios.post("/facturas", filtro);
    }

    public static async getFacturaByIdAsyc(id: string) {
        return await Axios.get(`${RESOURCE_NAME}/${id}`);
    }

    public static async grabarFacturasAsync(factura: Factura) {
        return await Axios.post(RESOURCE_NAME, factura);
        //return await Axios.post("Prueba");
    }

    public static async actualizarFacturaAsync(factura: Factura) {
        return await Axios.put(RESOURCE_NAME, factura);
        //return await Axios.put("Prueba");
    }
    public static async genearFicherosFacturaAsync(factura: Factura) {
        return await Axios.put(RESOURCE_NAME + '/generar/ficheros', factura);
    }

    public static async cambiarEstadoFacturaAsync(objEnvFac: CambiarEstadoFactura) {
        return await Axios.put(RESOURCE_NAME + '/cambiar/estado', objEnvFac);
    }

    public static async borrarFactura(id: string) {
        //return await Axios.delete("Prueba");
        return await Axios.delete(`${RESOURCE_NAME}/${id}`);
    }

    /*
    public static async downloadPdf(id: string) {
        //return await Axios.delete("Prueba");
        return await Axios.get(`${RESOURCE_NAME}/pdf/` + id);
    }*/

    public static async getDatosEmailFacturaAsync(id: string) {
        return await Axios.get(`${RESOURCE_NAME}/${id}/datosemail`);
    }

    public static async enviarFacturaAsyc(datos: EnviarFactura) {
        return await Axios.post(`${RESOURCE_NAME}/enviar`, datos);
    }

    public static async enviarFacturaHaciendaAsyc(id: string) {
        return await Axios.post(`${RESOURCE_NAME}/${id}/enviarHacienda`);
    }

    public static async getMetodosPagos(id: string) {
        return await Axios.get(`${RESOURCE_NAME}/metodospago/${id}`);
    }

    public static async getSeguimentoFacturaAsync(id: string) {
        return await Axios.post(`${RESOURCE_NAME}/seguimiento/${id}`);
    }
    
    public static async actualizarFicheroFacturaAsync(fichero: Fichero) {
        return await Axios.post(`${RESOURCE_NAME}/actualizar/fichero`,fichero);
    }
    
    public static async actualizarContrapartidaFacturaAsync(item: FacturaDetalleImpuestoCambiarContrapartida) {
        return await Axios.post(`${RESOURCE_NAME}/actualizar/contrapartida`,item);
    }

    public static async grabarCuentaContableAsync(item: FacturaCuentaContable) {
        return await Axios.post(`${RESOURCE_NAME}/actualizar/cuenta_contable`,item);
    }
   
    public static async grabarProgramacionReplicacionAsyc(item: ReplicacionFactura) {
        return await Axios.post(`${RESOURCE_NAME}/programar/replicacion`, item);
    }

    public static async bloquearProgramacionReplicacionAsyc(id_factura: string) {
        return await Axios.put(`${RESOURCE_NAME}/bloquear/replicacion/${id_factura}`);
    }

    public static async borrarProgramacionReplicacionAsyc(id_factura: string) {
        return await Axios.delete(`${RESOURCE_NAME}/borrar/replicacion/${id_factura}`);
    }
    
    public static async getFicheroPDFFacturaAsync(id: string) {
        return await Axios.get(`${RESOURCE_NAME}/prueba/generar/descargar/pdf/${id}`);
    }

    public static async getFicheroXMLFacturaAsync(id: string) {
        return await Axios.get(`${RESOURCE_NAME}/prueba/generar/descargar/xml/${id}`);
    }

    public static async getFicheroXMLFirmadoFacturaAsync(id: string) {
        return await Axios.get(`${RESOURCE_NAME}/prueba/generar/xml/firmado/${id}`);
    }
        
}